import { Client, StompConfig, TickerStrategy, Versions } from '@stomp/stompjs';
import { Dispatch } from 'redux';
import { RootState } from 'app/AppStore';
import { getBrokerUrl } from 'domains/webSockets/utils/utils';
import { env } from 'env';
import {
  beforeConnectCollector,
  onConnect,
  onDisconnect,
  onStompError,
  onWebSocketError,
  onWebSocketClose,
} from './stompEventHandlers';

const bffUrl = env.REACT_APP_BFF_USER_BEHAVIOUR_URL;
const brokerURL = getBrokerUrl(bffUrl);

export const setupUserBehaviourMonitoringStompClient = (dispatch: Dispatch, getState: () => RootState): Client => {
  const heartbeatIncoming = 60000;
  const heartbeatOutgoing = 60000;
  const reconnectDelay = 2000;
  const stompConfig: StompConfig = {
    heartbeatIncoming,
    heartbeatOutgoing,
    brokerURL,
    reconnectDelay,
    stompVersions: new Versions(['1.2', '1.1', '1.0']),
    splitLargeFrames: true,
    heartbeatStrategy: TickerStrategy.Worker,
  };
  const client = new Client(stompConfig);

  client.beforeConnect = () => beforeConnectCollector(client, dispatch, getState);
  client.onConnect = (frame) => onConnect(dispatch, frame);
  client.onDisconnect = (frame) => onDisconnect(dispatch, frame);
  client.onStompError = (frame) => onStompError(dispatch, frame);
  client.onWebSocketError = (event) => onWebSocketError(dispatch, event);
  client.onWebSocketClose = (event) => onWebSocketClose(dispatch, event);

  return client;
};
